module.exports = __webpack_public_path__ + "img/Path 532.f2f0f389.svg";